import React, { memo } from 'react';
import logo from '../assets/images/logo.webp';
const Logo = memo(() => {
  return (
    <div className="flex items-center">
      <span className=" p-4 text-8xl lg:text-5xl letter-spacing-3 font-bold text-white transition-colors duration-300">
        
        <img
  src={logo}
  alt="Logo"
  className="w-32 sm:w-48 object-contain mx-auto"
/>

</span>
    </div>
  );
});

export default Logo;